/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
import clsx from 'clsx';
import { useEffect, useState } from 'react';

import { usePersistentGlobalStore } from '@marriott/mi-store-utils';
import { BrandFilter } from '@marriott/mi-shop-components';
import { Button, Modal, CheckboxControlsList, RadiobuttonControlsList } from '@marriott/mi-ui-library';
import { INTERNAL_CTA_TYPE } from 'libs/mi-offers-components/src/constants/CommonConstants';

import { isOnlyCurrencyChanged } from '../utils/helper';
import { ShowPriceTaxFilter } from './priceTaxFilter/priceTaxFilter';
import {
  BrandProps,
  CheckboxControlsListProps,
  ControlsProps,
  availableBrandsType,
  brandCategoriesDataType,
  brandCategoryTitleMappingType,
  brandFilterProps,
} from './PropertiesListFilter.types';
import { StyledSearchAllFilters } from './PropertiesListFilter.styles';

export const PropertiesListFilter: React.FC<any> = props => {
  const globalData = usePersistentGlobalStore((state: any) => state.globalData);
  const ariesOffer = globalData?.sessionData?.cacheData?.data?.AriesOffer;
  const [popupOpenState, setPopupOpenState] = useState<boolean>(false);
  const acceptLanguage = props?.acceptLanguage;
  const countryCode = props?.countryCode;
  const [isTaxSliderActive, setIsTaxSliderActive] = useState<boolean>(props?.isTaxSliderActive);
  const [isNewFacetsLoading, setIsNewFacetsLoading] = useState<boolean>(props?.isNewFacetsLoading);
  const model = props.model;
  const disableCountryFilter = model?.disableCountryFilter ?? false;
  const isFlexibleSearch = props?.mpoFlexibleDate;
  const isCurrencyFilterEnabled =
    Array.isArray(model?.currencyListArray) && model?.currencyListArray.length > 0 && !isFlexibleSearch; // Do not show price filter during flexible search or if currency is not authored in the AEM model
  const [filterCategoryModal, setFilterCategoryModal] = useState<string>('All Filters');
  const [filterCategoryHeader, setFilterCategoryHeader] = useState<string>(model?.allFilters ?? 'All Filters');
  const [selectedBrands, setSelectedBrands] = useState<BrandProps[]>([]);
  const [selectedCountries, setSelectedCountries] = useState<ControlsProps[]>([]);
  const [selectedStates, setSelectedStates] = useState<ControlsProps[]>([]);
  const [selectedCities, setSelectedCities] = useState<ControlsProps[]>([]);
  const [isCategoryFilterModal, setIsCategoryFilterModal] = useState<boolean>(false);
  //amenities
  const [selectedAmenities, setSelectedAmenities] = useState<ControlsProps[]>(props?.selectedAmenities);
  //transportation
  const [selectedTransportation, setselectedTransportation] = useState<ControlsProps[]>(props?.selectedTransportation);
  // hotel type
  const [selectedHotelType, setSelectedHotelType] = useState<ControlsProps[]>(props?.selectedHotelType);
  //events
  const [selectedEvents, setSelectedEvents] = useState<ControlsProps[]>(props?.selectedEvents);
  //activities
  const [selectedActivities, setSelectedActivities] = useState<ControlsProps[]>(props?.selectedActivities);
  //currency
  const [selectedCurrency, setSelectedCurrency] = useState<ControlsProps[]>(props?.selectedCurrency);

  const isFilterSelected =
    ((props?.variation === 'sbo' ? 0 : ariesOffer?.['selectedBrands']?.length) ?? 0) +
    (ariesOffer?.['selectedCountries']?.length ?? 0) +
    (ariesOffer?.['selectedStates']?.length ?? 0) +
    (ariesOffer?.['selectedCities']?.length ?? 0) +
    (ariesOffer?.['selectedAmenities']?.length ?? 0) +
    (ariesOffer?.['selectedTransportation']?.length ?? 0) +
    (ariesOffer?.['selectedHotelType']?.length ?? 0) +
    (ariesOffer?.['selectedEvents']?.length ?? 0) +
    (ariesOffer?.['selectedActivities']?.length ?? 0) +
    (ariesOffer?.['selectedCurrency']?.length > 0
      ? ariesOffer?.['selectedCurrency']?.[0]?.label !== (model?.defaultLabel ?? 'Default')
        ? 1
        : 0
      : 0);

  const brandCategoriesData: brandCategoriesDataType = [];
  useEffect(() => {
    setSelectedBrands(props.selectedBrands);
    setSelectedCountries(props?.selectedCountries);
    setSelectedStates(props?.selectedStates);
    setSelectedCities(props?.selectedCities);
    setIsTaxSliderActive(props?.isTaxSliderActive);
    setSelectedAmenities(props?.selectedAmenities);
    setselectedTransportation(props?.selectedTransportation);
    setSelectedHotelType(props?.selectedHotelType);
    setSelectedEvents(props?.selectedEvents);
    setSelectedActivities(props?.selectedActivities);
    setSelectedCurrency(props?.selectedCurrency);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.selectedBrands.length,
    props?.selectedCountries?.length,
    props?.selectedStates,
    props?.selectedCities,
    props?.isTaxSliderActive,
    props?.selectedAmenities,
    props?.selectedTransportation?.length,
    props?.selectedHotelType?.length,
    props?.selectedEvents?.length,
    props?.selectedActivities?.length,
    props?.selectedCurrency?.length,
  ]);

  useEffect(() => {
    setIsNewFacetsLoading(props?.isNewFacetsLoading);
  }, [props?.isNewFacetsLoading]);

  const brandCategoryTitleMapping: brandCategoryTitleMappingType = {
    luxuryBrands: model?.storefrontPropertyBrandFilterLuxury,
    premiumBrands: model?.storefrontPropertyBrandFilterPremium,
    selectBrands: model?.storefrontPropertyBrandFilterSelect,
    longerStayBrands: model?.storefrontPropertyBrandFilterLongerStay,
  };

  const getBrandCategoriesData = (brandCategory: string) => {
    const brandsList = model?.brands[brandCategory].map((brand: { code: string; title: string }) => {
      const isDisabled = props.availableBrands?.some((item: availableBrandsType) => {
        return item.code === brand.code;
      });
      return {
        code: brand?.code,
        brandTagTitle: brand?.title,
        description: '',
        brandTagId: brand?.code,
        isDisabled: !isDisabled,
      };
    });
    const filteredBrandList = brandsList.filter((brand: any) => {
      return brand?.isDisabled !== true;
    });
    const key = brandCategory as keyof typeof brandCategoryTitleMapping; // to allow indexing on object
    const category = {
      categoryTitle: brandCategoryTitleMapping[key],
      categorySelectLabel: model?.storefrontPropertyBrandFilterSelectAll,
      categoryClearLabel: model?.storefrontPropertyFilterClear,
      brands: filteredBrandList,
    };
    filteredBrandList?.length && brandCategoriesData.push(category);
  };
  const getControlsData = (currentFilterData: any) => {
    const desiredKeys = ['code', 'count', 'label', 'description'];
    const updatedFilterOptions = currentFilterData?.map((obj: any) => {
      const newFilterOptionsObj: any = {};
      desiredKeys?.forEach(key => {
        newFilterOptionsObj[key] = obj[key];
      });
      const modifiedLabel = obj?.label ?? obj?.description ?? obj?.code;
      return { ...newFilterOptionsObj, label: modifiedLabel };
    });
    return updatedFilterOptions;
  };
  getBrandCategoriesData('luxuryBrands');
  getBrandCategoriesData('premiumBrands');
  getBrandCategoriesData('selectBrands');
  getBrandCategoriesData('longerStayBrands');

  const handleBrandFilter = (selectedBrandAr: any) => {
    setSelectedBrands(selectedBrandAr);
    props.handleApplyFilter(
      false,
      selectedBrandAr,
      selectedAmenities,
      selectedTransportation,
      selectedHotelType,
      selectedEvents,
      selectedActivities,
      selectedCountries,
      selectedStates,
      selectedCities,
      selectedCurrency,
      isTaxSliderActive
    );
  };
  const handleCountryChange = (selectedCountriesAr: any) => {
    setSelectedCountries(selectedCountriesAr);
    props.handleApplyFilter(
      false,
      selectedBrands,
      selectedAmenities,
      selectedTransportation,
      selectedHotelType,
      selectedEvents,
      selectedActivities,
      selectedCountriesAr,
      selectedStates,
      selectedCities,
      selectedCurrency,
      isTaxSliderActive
    );
  };
  const handleStateChange = (selectedStatesAr: any) => {
    setSelectedStates(selectedStatesAr);
    props.handleApplyFilter(
      false,
      selectedBrands,
      selectedAmenities,
      selectedTransportation,
      selectedHotelType,
      selectedEvents,
      selectedActivities,
      selectedCountries,
      selectedStatesAr,
      selectedCities,
      selectedCurrency,
      isTaxSliderActive
    );
  };
  const handleCityChange = (selectedCitiesAr: any) => {
    setSelectedCities(selectedCitiesAr);
    props.handleApplyFilter(
      false,
      selectedBrands,
      selectedAmenities,
      selectedTransportation,
      selectedHotelType,
      selectedEvents,
      selectedActivities,
      selectedCountries,
      selectedStates,
      selectedCitiesAr,
      selectedCurrency,
      isTaxSliderActive
    );
  };
  const handleDynamicPricesAndTax = (val: boolean) => {
    setIsTaxSliderActive(val);
    props.handleApplyFilter(
      false,
      selectedBrands,
      selectedAmenities,
      selectedTransportation,
      selectedHotelType,
      selectedEvents,
      selectedActivities,
      selectedCountries,
      selectedStates,
      selectedCities,
      selectedCurrency,
      val
    );
  };
  const handleAmenitiesChange = (selectedAmenitiesAr: any) => {
    setSelectedAmenities(selectedAmenitiesAr);
    props.handleApplyFilter(
      false,
      selectedBrands,
      selectedAmenitiesAr,
      selectedTransportation,
      selectedHotelType,
      selectedEvents,
      selectedActivities,
      selectedCountries,
      selectedStates,
      selectedCities,
      selectedCurrency,
      isTaxSliderActive
    );
  };
  const handleTransportationChange = (selectedTransportationAr: any) => {
    setselectedTransportation(selectedTransportationAr);
    props.handleApplyFilter(
      false,
      selectedBrands,
      selectedAmenities,
      selectedTransportationAr,
      selectedHotelType,
      selectedEvents,
      selectedActivities,
      selectedCountries,
      selectedStates,
      selectedCities,
      selectedCurrency,
      isTaxSliderActive
    );
  };
  const handleHotelTypeChange = (selectedHotelTypeAr: any) => {
    setSelectedHotelType(selectedHotelTypeAr);
    props.handleApplyFilter(
      false,
      selectedBrands,
      selectedAmenities,
      selectedTransportation,
      selectedHotelTypeAr,
      selectedEvents,
      selectedActivities,
      selectedCountries,
      selectedStates,
      selectedCities,
      selectedCurrency,
      isTaxSliderActive
    );
  };
  const handleEventsChange = (selectedEventsAr: any) => {
    setSelectedEvents(selectedEventsAr);
    props.handleApplyFilter(
      false,
      selectedBrands,
      selectedAmenities,
      selectedTransportation,
      selectedHotelType,
      selectedEventsAr,
      selectedActivities,
      selectedCountries,
      selectedStates,
      selectedCities,
      selectedCurrency,
      isTaxSliderActive
    );
  };
  const handleActivitiesChange = (selectedActivitiesAr: any) => {
    setSelectedActivities(selectedActivitiesAr);
    props.handleApplyFilter(
      false,
      selectedBrands,
      selectedAmenities,
      selectedTransportation,
      selectedHotelType,
      selectedEvents,
      selectedActivitiesAr,
      selectedCountries,
      selectedStates,
      selectedCities,
      selectedCurrency,
      isTaxSliderActive
    );
  };
  const handleCurrencyChange = (selectedCurrency: any) => {
    setSelectedCurrency(selectedCurrency);
  };

  const BrandFilterProps: brandFilterProps = {
    title: `${model?.storefrontPropertyBrandFilter}`,
    brandCategories: brandCategoriesData,
    showSeparator: false,
    // defaultSelected includes all those brands which are selected and highlited for filtering the properties.
    defaultSelected: selectedBrands,
    onChange: handleBrandFilter,
    isHotelBrandSelectedFlag: true,
    featureFlagLogo: props?.featureFlagLogo?.experience_mcom_logo_automation,
  };
  const CountryFilterProps: CheckboxControlsListProps = {
    title: `${model?.countryLabel ?? 'Country'}`,
    controls: getControlsData(props?.availableCountries),
    enableShowMoreToggle: true,
    defaultSelected: selectedCountries,
    onChange: handleCountryChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'filterCountry',
    showSeparator: true,
  };
  const StateFilterProps: CheckboxControlsListProps = {
    title: `${model?.stateLabel ?? 'State'}`,
    controls: getControlsData(props?.availableStates),
    enableShowMoreToggle: true,
    defaultSelected: selectedStates,
    onChange: handleStateChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'filterState',
    showSeparator: true,
  };
  const CityFilterProps: CheckboxControlsListProps = {
    title: `${model?.cityLabel ?? 'City'}`,
    controls: getControlsData(props?.availableCities),
    enableShowMoreToggle: true,
    defaultSelected: selectedCities,
    onChange: handleCityChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'filterCity',
    showSeparator: true,
  };
  const AmenitiesFilterProps: CheckboxControlsListProps = {
    title: `${model?.amenitiesLabel ?? 'Amenities'}`,
    controls: getControlsData(props?.availabledAmenities),
    enableShowMoreToggle: true,
    defaultSelected: selectedAmenities,
    onChange: handleAmenitiesChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'Amenities',
    showSeparator: true,
  };
  const TransportationFilterProps: CheckboxControlsListProps = {
    title: `${model?.transportationLabel ?? 'Transportation'}`,
    controls: getControlsData(props?.availableTransportation),
    enableShowMoreToggle: true,
    defaultSelected: selectedTransportation,
    onChange: handleTransportationChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'Transportation',
    showSeparator: true,
  };
  const HotelTypeFilterProps: CheckboxControlsListProps = {
    title: `${model?.hotelTypeSearchLabel ?? 'Property Type'}`,
    controls: getControlsData(props?.availableHotelType),
    enableShowMoreToggle: true,
    defaultSelected: selectedHotelType, //getSelectedHotelType(props?.availableHotelType, selectedHotelType),
    onChange: handleHotelTypeChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'HotelType',
    showSeparator: true,
  };
  const EventsFilterProps: CheckboxControlsListProps = {
    title: `${model?.eventsLabel ?? 'Events'}`,
    controls: getControlsData(props?.availablEvents),
    enableShowMoreToggle: true,
    defaultSelected: selectedEvents,
    onChange: handleEventsChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'Events',
    showSeparator: true,
  };
  const ActivitiesFilterProps: CheckboxControlsListProps = {
    title: `${model?.activitiesLabel ?? 'Activities'}`,
    controls: getControlsData(props?.availablActivities),
    enableShowMoreToggle: true,
    defaultSelected: selectedActivities,
    onChange: handleActivitiesChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'Activities',
    showSeparator: true,
  };
  const CurrencyFilterProps: any = {
    eyebrowText: `${model?.showPriceInLabel ?? 'SHOW PRICE IN'}`,
    controls: isCurrencyFilterEnabled
      ? [
          {
            label: model?.defaultLabel ?? 'Default',
            code: '',
          },
          ...model.currencyListArray.map((c: { currencyTag: string }) => ({
            label: c.currencyTag,
            code: c.currencyTag,
          })),
        ]
      : [],
    enableShowMoreToggle: true,
    defaultSelected: selectedCurrency,
    onChange: handleCurrencyChange,
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'currency',
    showSeparator: true,
  };

  const toggleModal = () => {
    // opens/closes the modal
    setPopupOpenState(!popupOpenState);

    // and resets the filter UI to match the latest applied filters.
    setSelectedBrands(ariesOffer?.['selectedBrands'] ?? []);
    setSelectedCountries(ariesOffer?.['selectedCountries'] ?? []);
    setSelectedStates(ariesOffer?.['selectedStates'] ?? []);
    setSelectedCities(ariesOffer?.['selectedCities'] ?? []);
    setIsTaxSliderActive(
      ariesOffer?.['showPricesTax'] === true || ariesOffer?.['showPricesTax'] === false
        ? ariesOffer?.['showPricesTax']
        : acceptLanguage === 'ja-JP' || acceptLanguage === 'en-GB' || countryCode === 'UK'
        ? true
        : false
    );
    setSelectedAmenities(ariesOffer?.['selectedAmenities'] ?? []);
    setselectedTransportation(ariesOffer?.['selectedTransportation'] ?? []);
    setSelectedHotelType(ariesOffer?.['selectedHotelType'] ?? []);
    setSelectedEvents(ariesOffer?.['selectedEvents'] ?? []);
    setSelectedActivities(ariesOffer?.['selectedActivities'] ?? []);
    setSelectedCurrency(
      ariesOffer?.['selectedCurrency']?.length ? ariesOffer?.['selectedCurrency'] : props?.selectedCurrency
    );
  };
  const handleClearBtn = () => {
    if (filterCategoryModal === 'All Filters') {
      setSelectedBrands([]);
      setIsTaxSliderActive(
        acceptLanguage === 'ja-JP' || acceptLanguage === 'en-GB' || countryCode === 'UK' ? true : false
      );
      setSelectedCountries([]);
      setSelectedStates([]);
      setSelectedCities([]);
      //clear ammenities
      setSelectedAmenities([]);
      //clear transportation
      setselectedTransportation([]);
      //clear hotels
      setSelectedHotelType([]);
      //clear events
      setSelectedEvents([]);
      //reset currency to default
      setSelectedCurrency([
        {
          label: model?.defaultLabel ?? 'Default',
          code: '',
          disabled: false,
        },
      ]);
      //clear activities
      setSelectedActivities([]);
    } else if (filterCategoryModal === 'Brands') {
      setSelectedBrands([]);
    } else if (filterCategoryModal === 'Amenities') {
      setSelectedAmenities([]);
    }
    props.handleClearAllFilters(filterCategoryModal);
  };
  const handleApplyBtnClick = () => {
    const currentFilters = {
      selectedBrands,
      selectedAmenities,
      selectedTransportation,
      selectedHotelType,
      selectedEvents,
      selectedActivities,
      selectedCountries,
      selectedStates,
      selectedCities,
      isTaxSliderActive,
      selectedCurrency,
    };
    const previousFilters = {
      selectedBrands: props?.selectedBrands,
      selectedAmenities: props?.selectedAmenities,
      selectedTransportation: props?.selectedTransportation,
      selectedHotelType: props?.selectedHotelType,
      selectedEvents: props?.selectedEvents,
      selectedActivities: props?.selectedActivities,
      selectedCountries: props?.selectedCountries,
      selectedStates: props?.selectedStates,
      selectedCities: props?.selectedCities,
      isTaxSliderActive: props?.isTaxSliderActive,
      selectedCurrency: props?.selectedCurrency,
    };

    if (isOnlyCurrencyChanged(previousFilters, currentFilters)) {
      props.handleApplyCurrencyFilter(selectedCurrency);
    } else {
      props.handleApplyFilter(
        true,
        selectedBrands,
        selectedAmenities,
        selectedTransportation,
        selectedHotelType,
        selectedEvents,
        selectedActivities,
        selectedCountries,
        selectedStates,
        selectedCities,
        selectedCurrency,
        isTaxSliderActive
      );
    }
  };
  const getModalData = (): any => {
    if (filterCategoryModal === 'All Filters') {
      return (
        <>
          {/* Show Price In */}
          {isCurrencyFilterEnabled ? <RadiobuttonControlsList {...CurrencyFilterProps} /> : null}
          {/* Brands */}
          {props?.availableBrands?.length > 1 && (
            <>
              <BrandFilter {...BrandFilterProps} />
              <hr className="filter-separator" aria-hidden="true" />
            </>
          )}
          {AmenitiesFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...AmenitiesFilterProps} /> : null}
          {TransportationFilterProps?.controls?.length > 0 ? (
            <CheckboxControlsList {...TransportationFilterProps} />
          ) : null}
          {HotelTypeFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...HotelTypeFilterProps} /> : null}
          {EventsFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...EventsFilterProps} /> : null}
          {ActivitiesFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...ActivitiesFilterProps} /> : null}
          {!disableCountryFilter && CountryFilterProps?.controls?.length > 0 ? (
            <CheckboxControlsList {...CountryFilterProps} />
          ) : null}
          {StateFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...StateFilterProps} /> : null}
          {CityFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...CityFilterProps} /> : null}
        </>
      );
    } else if (filterCategoryModal === 'Amenities') {
      return AmenitiesFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...AmenitiesFilterProps} /> : null;
    } else if (filterCategoryModal === 'Brands') {
      return <BrandFilter {...BrandFilterProps} />;
    }
  };

  return (
    <StyledSearchAllFilters className="offer-filters">
      <div className="filter-btns-wrapper">
        <Button
          callback={(): void => {
            setFilterCategoryModal('All Filters');
            setFilterCategoryHeader(model?.allFilters ?? 'All Filters');
            toggleModal();
          }}
          className={clsx(
            `button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button ${
              isFilterSelected && 'active'
            }`
          )}
          custom_click_track_value={`${model?.id}|${model?.storefrontPropertyBrandFilter}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          trackingProperties={model?.trackingProperties}
        >
          <span className={`icon-s ${isFilterSelected ? ' all-filter-badge' : 'icon-dining-filter'}`}>
            {' '}
            {`${isFilterSelected ? isFilterSelected : ''}`}
          </span>
          {model?.allFilters}
        </Button>
        {props?.availableBrands?.length > 1 && (
          <Button
            callback={(): void => {
              setFilterCategoryModal('Brands');
              setFilterCategoryHeader(model?.storefrontPropertyBrandFilter);
              toggleModal();
            }}
            className={clsx(
              'button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button',
              ariesOffer?.['selectedBrands']?.length > 0 ? 'active' : ''
            )}
            custom_click_track_value={`${model?.id}|${model?.storefrontPropertyBrandFilter}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          >
            {model?.storefrontPropertyBrandFilter}
          </Button>
        )}
      </div>
      {popupOpenState && (
        <Modal
          className={`custom-scrollbar modal-main-container ${popupOpenState && 'close-popup-header'} ${
            isCategoryFilterModal && 'category-filter-modal'
          }`}
          show={true}
          handleBlur={true}
          popupOpenState={popupOpenState}
          setPopupOpenState={setPopupOpenState}
          disableScrollOnBody={true}
          allFilterPopUp={true}
          onClose={(): void => {
            setPopupOpenState(false);
          }}
        >
          {isNewFacetsLoading && (
            <div
              className="loader-container d-flex align-items-center justify-content-center"
              data-testid="facets-spinner"
            >
              <div className="m-spinner-m"></div>
            </div>
          )}
          <Modal.Header
            className="modal-header t-subtitle-xl"
            labelText={filterCategoryHeader}
            popupHeaderOnCLoseFunc={(): void => {
              setIsCategoryFilterModal(false);
              setPopupOpenState(false);
            }}
            closeIconClickTrackValue={`${model?.id}|close Modal|${INTERNAL_CTA_TYPE}`}
          />
          <Modal.Body className="all-filters custom-scrollbar">
            <div>
              {
                <ShowPriceTaxFilter
                  isTaxSliderActive={isTaxSliderActive}
                  handleDynamicPricesAndTax={handleDynamicPricesAndTax}
                  filterTaxesLabel={model?.filterTaxesLabel ?? 'Show rates with taxes and all fees'}
                />
              }
              <div>{getModalData()}</div>
            </div>
          </Modal.Body>
          <Modal.Footer
            clearClickHandler={handleClearBtn}
            setPopUpOpenState={setPopupOpenState}
            applyBtnClickHandler={handleApplyBtnClick}
            clearButtonLabel={model?.clearFilters}
            applyLabel={model?.storefrontPropertyFilterApply}
            className="modal-footer"
            clickTrackingLoc={'SEARCH_FILTER_MODAL'}
            applyBtnClickTrackValue={`${model?.id}|${model?.storefrontPropertyFilterApply}|${INTERNAL_CTA_TYPE}`}
            clearBtnClickTrackValue={`${model?.id}|${model?.clearFilters}|${INTERNAL_CTA_TYPE}`}
          />
        </Modal>
      )}
    </StyledSearchAllFilters>
  );
};
